export default class Config {
  // local url new
  // static baseUrl = "http://localhost:8000/api/";

  // UAT
  static baseUrl = "https://api-staging.tissuevault.health/api/";
  
  // for dashboarding
  static ColumnConfigs = {
    DistributorHomeInvoiceTable: [
      {
        displayName: "Invoice ID",
        backendName: "ID",
        isDisplayed: false,
      },
      {
        displayName: "Invoice",
        backendName: "InvoiceNumber",
        isDisplayed: true,
      },
      {
        displayName: "Order Date",
        backendName: "OrderDate",
        isDisplayed: true,
      },
      {
        displayName: "Due Date",
        backendName: "InvoiceDueDate",
        isDisplayed: true,
      },
      {
        displayName: "Due In",
        backendName: "DueIn",
        isDisplayed: true,
      },
      {
        displayName: "Account ID",
        backendName: "AccountID",
        isDisplayed: false,
      },
      {
        displayName: "Account Name",
        backendName: "AccountName",
        isDisplayed: true,
      },
      {
        displayName: "Manufacturer ID",
        backendName: "ManufacturerID",
        isDisplayed: false,
      },
      {
        displayName: "Manufacturer",
        backendName: "ManufacturerName",
        isDisplayed: true,
      },
      {
        displayName: "Total",
        backendName: "InvoiceTotal",
        isDisplayed: true,
      },
      {
        displayName: "Open Balance",
        backendName: "OpenBalance",
        isDisplayed: true,
      },
      {
        displayName: "Action",
        backendName: "",
        isDisplayed: true,
        isFormatter: true,
        formatterType: "redirectButton",
      },
    ],
    AccountHomeInvoiceTable: [
      {
        displayName: "Invoice ID",
        backendName: "ID",
        isDisplayed: false,
      },
      {
        displayName: "Invoice",
        backendName: "InvoiceNumber",
        isDisplayed: true,
      },
      {
        displayName: "Order Date",
        backendName: "OrderDate",
        isDisplayed: false,
      },
      {
        displayName: "Invoice Date",
        backendName: "InvoiceDate",
        isDisplayed: true,
      },
      {
        displayName: "Due Date",
        backendName: "InvoiceDueDate",
        isDisplayed: true,
      },
      {
        displayName: "Due In",
        backendName: "DueIn",
        isDisplayed: true,
      },
      {
        displayName: "Account ID",
        backendName: "AccountID",
        isDisplayed: false,
      },
      {
        displayName: "Account Name",
        backendName: "AccountName",
        isDisplayed: true,
      },
      {
        displayName: "Manufacturer ID",
        backendName: "ManufacturerID",
        isDisplayed: false,
      },
      {
        displayName: "Manufacturer",
        backendName: "ManufacturerName",
        isDisplayed: true,
      },
      {
        displayName: "Total",
        backendName: "InvoiceTotal",
        isDisplayed: true,
      },
      {
        displayName: "Open Balance",
        backendName: "OpenBalance",
        isDisplayed: true,
      },
      {
        displayName: "Action",
        backendName: "",
        isDisplayed: true,
        isFormatter: true,
        formatterType: "redirectButton",
      },
    ],
    AccountHomeRecentOrders: [
      {
        displayName: "Order ID",
        backendName: "ID",
        isDisplayed: false,
      },
      {
        displayName: "PO Number",
        backendName: "PONumber",
        isDisplayed: true,
      },
      {
        displayName: "Order Date",
        backendName: "OrderDate",
        isDisplayed: true,
      },
      {
        displayName: "Order Total",
        backendName: "OrderTotal",
        isDisplayed: true,
      },
      {
        displayName: "Status",
        backendName: "Status",
        isDisplayed: true,
      },
      {
        displayName: "Action",
        backendName: "",
        isDisplayed: true,
        isFormatter: true,
        formatterType: "redirectButton",
      },
    ],
    AccountDashboard: [
      {
        displayName: "Account ID",
        backendName: "ID",
        isDisplayed: false,
        // isFormatter: true,
        // formatterType: 'redirect'
      },
      {
        displayName: "Is Child Account",
        backendName: "IsChildAccount",
        isDisplayed: false,
        // isFormatter: true,
        // formatterType: 'redirect'
      },
      {
        displayName: "Account Name",
        backendName: "AccountName",
        isDisplayed: true,
        isSearchable: true,
      },
      {
        displayName: "Distributor ID",
        backendName: "DistributorID",
        isDisplayed: false,
      },
      {
        displayName: "Distributor",
        backendName: "DistributorName",
        isDisplayed: true,
      },
      {
        displayName: "Region",
        backendName: "RegionName",
        isDisplayed: true,
      },
      {
        displayName: "Orders YTD",
        backendName: "OrdersYTD",
        isDisplayed: true,
      },
      {
        displayName: "Sales YTD",
        backendName: "SalesYTD",
        isDisplayed: true,
      },
      {
        displayName: "Total Purchased for all Accounts",
        backendName: "TotalPurchasedAllAccountsYTD",
        isDisplayed: true,
      },
      {
        displayName: "Open Balance",
        backendName: "OpenBalance",
        isDisplayed: true,
      },
      {
        displayName: "Past Due",
        backendName: "OpenBalancePastDueDate",
        isDisplayed: true,
      },
      {
        displayName: "Days Since Last Order",
        backendName: "DaysSinceLastDirectOrder",
        isDisplayed: true,
      },
      {
        displayName: "Action",
        backendName: "",
        isDisplayed: true,
        isFormatter: true,
        formatterType: "redirectButton",
      },
    ],
    AccountUsers: [
      {
        displayName: "ID",
        backendName: "ID",
        isDisplayed: false,
      },
      {
        displayName: "User ID",
        backendName: "UserID",
        isDisplayed: false,
      },
      {
        displayName: "Account ID",
        backendName: "AccountID",
        isDisplayed: false,
      },
      {
        displayName: "First Name",
        backendName: "FirstName",
        isDisplayed: false,
      },
      {
        displayName: "Last Name",
        backendName: "LastName",
        isDisplayed: false,
      },
      {
        displayName: "Name",
        backendName: "Name",
        isDisplayed: true,
      },
      {
        displayName: "Role",
        backendName: "RoleType",
        isDisplayed: false,
      },
      {
        displayName: "Role",
        backendName: "Role",
        isDisplayed: true,
      },
      {
        displayName: "Email",
        backendName: "Email",
        isDisplayed: true,
      },
      {
        displayName: "Phone",
        backendName: "Phone",
        isDisplayed: true,
      },
      {
        displayName: "Provider NPI",
        backendName: "ProviderNPI",
        isDisplayed: true,
      },
      {
        displayName: "Notes",
        backendName: "Notes",
        isDisplayed: true,
      },
      {
        displayName: "Action",
        backendName: "",
        isDisplayed: true,
        isFormatter: true,
        formatterType: "redirectButton",
      },
    ],
    DistributorUsers: [
      {
        displayName: "ID",
        backendName: "ID",
        isDisplayed: false,
      },
      {
        displayName: "User ID",
        backendName: "UserID",
        isDisplayed: false,
      },
      {
        displayName: "Distributor ID",
        backendName: "DistributorID",
        isDisplayed: false,
      },
      {
        displayName: "First Name",
        backendName: "FirstName",
        isDisplayed: true,
      },
      {
        displayName: "Last Name",
        backendName: "LastName",
        isDisplayed: true,
      },
      {
        displayName: "Email",
        backendName: "Email",
        isDisplayed: true,
      },
      {
        displayName: "Phone",
        backendName: "Phone",
        isDisplayed: true,
      },
      {
        displayName: "Role",
        backendName: "RoleType",
        isDisplayed: true,
      },
      {
        displayName: "Action",
        backendName: "",
        isDisplayed: true,
        isFormatter: true,
        formatterType: "redirectButton",
      },
    ],
    DistributorDashboard: [
      {
        displayName: "Distributor ID",
        backendName: "ID",
        isDisplayed: false,
      },
      {
        displayName: "Distributor",
        backendName: "DistributorName",
        isDisplayed: true,
        isSearchable: true,
      },
      {
        displayName: "Accounts",
        backendName: "AccountsCount",
        isDisplayed: true,
      },
      {
        displayName: "Sales YTD",
        backendName: "SalesYTD",
        isDisplayed: true,
      },
      {
        displayName: "Active YTD",
        backendName: "",
        isDisplayed: true,
      },
      {
        displayName: "Sales MTD",
        backendName: "SalesMTD",
        isDisplayed: true,
      },
      {
        displayName: "Active MTD",
        backendName: "",
        isDisplayed: true,
      },
      {
        displayName: "IsActive",
        backendName: "IsActive",
        isDisplayed: false,
      },
      {
        displayName: "Action",
        backendName: "",
        isDisplayed: true,
        isFormatter: true,
        formatterType: "redirectButton",
      },
    ],
    ManufacturerDashboard: [
      {
        displayName: "Manufacturer ID",
        backendName: "ID",
        isDisplayed: false,
        isFormatter: true,
        formatterType: "redirect",
      },
      {
        displayName: "Manufacturer",
        backendName: "ManufacturerName",
        isDisplayed: true,
      },
      {
        displayName: "Manufacturer Number",
        backendName: "ManufacturerNumber",
        isDisplayed: false,
      },
      {
        displayName: "Manufacturer Abbreviation",
        backendName: "ManufacturerAbbreviation",
        isDisplayed: false,
      },
      {
        displayName: "Address Line 1",
        backendName: "AddressLine1",
        isDisplayed: false,
      },
      {
        displayName: "Address Line 2",
        backendName: "AddressLine2",
        isDisplayed: false,
      },
      {
        displayName: "City",
        backendName: "City",
        isDisplayed: false,
      },
      {
        displayName: "State",
        backendName: "State",
        isDisplayed: false,
      },
      {
        displayName: "ZIP",
        backendName: "ZIP",
        isDisplayed: false,
      },
      {
        displayName: "Direct Order Email",
        backendName: "ManufacturerEmailDO",
        isDisplayed: false,
      },
      {
        displayName: "Consignment Order Email",
        backendName: "ManufacturerEmailCO",
        isDisplayed: false,
      },
      {
        displayName: "Product Usage Email",
        backendName: "ManufacturerEmailPU",
        isDisplayed: false,
      },
      {
        displayName: "Phone",
        backendName: "Phone",
        isDisplayed: false,
      },
      {
        displayName: "Fax",
        backendName: "Fax",
        isDisplayed: false,
      },

      {
        displayName: "Accounts",
        backendName: "AccountsCount",
        isDisplayed: true,
      },
      {
        displayName: "Sales YTD",
        backendName: "SalesYTD",
        isDisplayed: true,
      },
      {
        displayName: "Active YTD",
        backendName: "ActiveYTD",
        isDisplayed: true,
      },
      {
        displayName: "Sales MTD",
        backendName: "SalesMTD",
        isDisplayed: true,
      },
      {
        displayName: "Active MTD",
        backendName: "ActiveMTD",
        isDisplayed: true,
      },
      {
        displayName: "Action",
        backendName: "",
        isDisplayed: true,
        isFormatter: true,
        formatterType: "redirectButton",
      },
    ],
    ManufacturerProduct: [
      {
        displayName: "Product ID",
        backendName: "ID",
        isDisplayed: false,
      },
      {
        displayName: "Manufacturer ID",
        backendName: "ManufacturerID",
        isDisplayed: false,
      },
      {
        displayName: "Manufacturer Name",
        backendName: "ManufacturerName",
        isDisplayed: false,
      },
      {
        displayName: "Product Name",
        backendName: "ProductName",
        isDisplayed: true,
      },
      {
        displayName: "Product Code",
        backendName: "ProductCode",
        isDisplayed: true,
      },
      {
        displayName: "Standard Price",
        backendName: "StandardPrice",
        isDisplayed: true,
      },
      {
        displayName: "Action",
        backendName: "",
        isDisplayed: true,
        isFormatter: true,
        formatterType: "viewProduct",
      },
    ],
    AccountManufacturer: [
      {
        displayName: "Account ID",
        backendName: "AccountID",
        isDisplayed: false,
      },
      {
        displayName: "Manufacturer ID",
        backendName: "ID",
        isDisplayed: false,
      },
      {
        displayName: "Manufacturer Name",
        backendName: "ManufacturerName",
        isDisplayed: true,
      },
      {
        displayName: "Is Approved",
        backendName: "IsApproved",
        isDisplayed: false,
      },
      {
        displayName: "Status",
        backendName: "Status",
        isDisplayed: true,
      },
      {
        displayName: "Action",
        backendName: "",
        isDisplayed: true,
        isFormatter: true,
        formatterType: "redirectButton",
      },
    ],
    ChildAccounts: [
      {
        displayName: "Account ID",
        backendName: "ID",
        isDisplayed: false,
        isFormatter: false,
      },
      {
        displayName: "Account Name",
        backendName: "AccountName",
        isDisplayed: true,
      },
      {
        displayName: "Action",
        backendName: "",
        isDisplayed: true,
        isFormatter: true,
        formatterType: "redirectButton",
      },
    ],
    DistributorAccount: [
      {
        displayName: "Account ID",
        backendName: "ID",
        isDisplayed: false,
      },
      {
        displayName: "Account Name",
        backendName: "AccountName",
        isDisplayed: true,
      },
      {
        displayName: "IsDistUserAssigned",
        backendName: "IsDistUserAssigned",
        isDisplayed: false,
      },
      {
        displayName: "Assigned To",
        backendName: "DistributorUserID",
        isDisplayed: false,
      },
      {
        displayName: "Assigned To",
        backendName: "DistributorUsername",
        isDisplayed: true,
      },
      {
        displayName: "Action",
        backendName: "",
        isDisplayed: true,
        isFormatter: true,
        formatterType: "redirectButton",
      },
    ],
    ProductPricing: [
      {
        displayName: "Product ID",
        backendName: "ID",
        isDisplayed: false,
      },
      {
        displayName: "AccountID",
        backendName: "AccountID",
        isDisplayed: false,
      },
      {
        displayName: "ManufacturerID",
        backendName: "ManufacturerID",
        isDisplayed: false,
      },
      {
        displayName: "Manufacturer",
        backendName: "ManufacturerName",
        isDisplayed: true,
      },
      {
        displayName: "Product Name",
        backendName: "ProductName",
        isDisplayed: true,
      },
      {
        displayName: "Product Code",
        backendName: "ProductCode",
        isDisplayed: true,
      },
      {
        displayName: "Standard Price",
        backendName: "StandardPrice",
        isDisplayed: false,
      },
      {
        displayName: "Price for this Account",
        backendName: "Price",
        isDisplayed: true,
        isEditable: true,
      },
      {
        displayName: "",
        backendName: "IsEnabledValue",
        isDisplayed: false,
      },
      {
        displayName: "Enable",
        backendName: "IsEnabled",
        isDisplayed: true,
        isFormatter: true,
        formatterType: "toggle",
      },
    ],
    OrderProduct: [
      {
        displayName: "Product ID",
        backendName: "ID",
        isDisplayed: false,
      },
      {
        displayName: "Product Name",
        backendName: "ProductName",
        isDisplayed: true,
      },
      {
        displayName: "Product Code",
        backendName: "ProductCode",
        isDisplayed: true,
      },
      {
        displayName: "Cost",
        backendName: "Price",
        isDisplayed: true,
      },
      {
        displayName: "Quantity",
        backendName: "Quantity",
        isDisplayed: true,
        isFormatter: true,
        formatterType: "input",
        isEditable: true,
      },
      {
        displayName: "ProductTotal",
        backendName: "ProductTotal",
        isDisplayed: true,
        isFormatter: true,
        formatterType: "non-editableInput",
      },
    ],
    Approvals: [
      {
        displayName: "ID",
        backendName: "ID",
        isDisplayed: false,
        // isFormatter: true,
        // formatterType: 'redirect'
      },

      {
        displayName: "Order Date",
        backendName: "OrderDate",
        isDisplayed: true,
      },
      {
        displayName: "PO Number",
        backendName: "PONumber",
        isDisplayed: true,
        isSearchable: true,
      },
      {
        displayName: "Account ID",
        backendName: "AccountID",
        isDisplayed: false,
      },
      {
        displayName: "Account",
        backendName: "AccountName",
        isDisplayed: true,
      },
      {
        displayName: "Manufacturer",
        backendName: "ManufacturerName",
        isDisplayed: true,
      },
      {
        displayName: "ManufacturerID",
        backendName: "ManufacturerID",
        isDisplayed: false,
      },
      {
        displayName: "Order Type",
        backendName: "OrderType",
        isDisplayed: true,
      },
      {
        displayName: "Order Total",
        backendName: "OrderTotal",
        isDisplayed: true,
      },
      {
        displayName: "Action",
        backendName: "",
        isDisplayed: true,
        isFormatter: true,
        formatterType: "modalButtonApprovalsDashboard",
      },
    ],
    Orders: [
      {
        displayName: "ID",
        backendName: "ID",
        isDisplayed: false,
      },
      {
        displayName: "PO Number",
        backendName: "PONumber",
        isDisplayed: true,
        isSearchable: true,
      },
      {
        displayName: "Application Number",
        backendName: "ApplicationNumber",
        isDisplayed: false,
      },
      {
        displayName: "Order Date",
        backendName: "OrderDate",
        isDisplayed: true,
        type: "date",
      },
      {
        displayName: "Order Type",
        backendName: "OrderType",
        isDisplayed: true,
      },
      {
        displayName: "Account ID",
        backendName: "AccountID",
        isDisplayed: false,
      },
      {
        displayName: "Account",
        backendName: "AccountName",
        isDisplayed: false,
      },
      {
        displayName: "Ship to Account ID",
        backendName: "ShipToAccountID",
        isDisplayed: false,
      },
      {
        displayName: "Ship to Account",
        backendName: "ShipToAccountName",
        isDisplayed: true,
      },
      {
        displayName: "Manufacturer",
        backendName: "ManufacturerName",
        isDisplayed: true,
      },
      {
        displayName: "ManufacturerID",
        backendName: "ManufacturerID",
        isDisplayed: false,
      },
      {
        displayName: "Order Total",
        backendName: "OrderTotal",
        isDisplayed: true,
      },
      {
        displayName: "Status",
        backendName: "Status",
        isDisplayed: true,
        isSpecial: true,
      },
      {
        displayName: "Is Invoice Generated",
        backendName: "IsInvoiceGenerated",
        isDisplayed: false,
      },
      {
        displayName: "Invoice ID",
        backendName: "InvoiceID",
        isDisplayed: false,
      },
      {
        displayName: "IsShipped",
        backendName: "IsShipped",
        isDisplayed: false,
      },
      {
        displayName: "Action",
        backendName: "",
        isDisplayed: true,
        isFormatter: true,
        formatterType: "redirectButton",
        // 44214400 00042417
        // 9/31
        // 112
      },
    ],
    OrderProductInvoice: [
      {
        displayName: "ID",
        backendName: "ID",
        isDisplayed: false,
      },
      {
        displayName: "Tissue ID",
        backendName: "TissueID",
        isDisplayed: true,
        isEditable: true,
      },
      {
        displayName: "Product Code",
        backendName: "ProductCode",
        isDisplayed: true,
      },
      {
        displayName: "Product Cost",
        backendName: "Price",
        isDisplayed: true,
      },
    ],
    InvoiceDashboard: [
      {
        displayName: "QBO Invoice ID",
        backendName: "QBOInvoiceID",
        isDisplayed: true,
      },
      {
        displayName: "ID",
        backendName: "ID",
        isDisplayed: false,
      },
      {
        displayName: "Icon",
        backendName: "Icon",
        isDisplayed: true,
        isSpecial: true,
      },
      {
        displayName: "Total Payments Applied",
        backendName: "TotalPaymentsApplied",
        isDisplayed: false,
      },
      {
        displayName: "Invoice Number",
        backendName: "InvoiceNumber",
        isDisplayed: true,
      },
      {
        displayName: "PONumber",
        backendName: "PONumber",
        isDisplayed: true,
        isSearchable: true,
      },
      {
        displayName: "Invoice Date",
        backendName: "InvoiceDate",
        isDisplayed: true,
        type: "date",
      },
      {
        displayName: "Due Date",
        backendName: "InvoiceDueDate",
        isDisplayed: true,
        type: "date",
      },
      {
        displayName: "Account ID",
        backendName: "AccountID",
        isDisplayed: false,
      },
      {
        displayName: "Account Name",
        backendName: "AccountName",
        isDisplayed: true,
      },
      {
        displayName: "Manufacturer ID",
        backendName: "ManufacturerID",
        isDisplayed: false,
      },
      {
        displayName: "Manufacturer Name",
        backendName: "ManufacturerName",
        isDisplayed: true,
      },
      {
        displayName: "Total",
        backendName: "InvoiceTotal",
        isDisplayed: true,
      },
      {
        displayName: "Action",
        backendName: "",
        isDisplayed: true,
        isFormatter: true,
        formatterType: "redirectButton",
      },
    ],
    InvoiceHomeOrderProducts: [
      {
        displayName: "ID",
        backendName: "ID",
        isDisplayed: false,
      },
      {
        displayName: "Tissue ID",
        backendName: "TissueID",
        isDisplayed: true,
      },
      {
        displayName: "Product Code",
        backendName: "ProductCode",
        isDisplayed: true,
      },
      {
        displayName: "Cost",
        backendName: "Price",
        isDisplayed: true,
      },
      {
        displayName: "Action",
        backendName: "",
        isDisplayed: true,
        isFormatter: true,
        formatterType: "redirectButton",
      },
    ],
    InvoiceHomeOrderDetails: [
      {
        displayName: "PONumber",
        backendName: "PONumber",
        isDisplayed: true,
      },
      {
        displayName: "Order Type",
        backendName: "OrderType",
        isDisplayed: true,
      },
      {
        displayName: "Order Date",
        backendName: "OrderDate",
        isDisplayed: true,
      },
      {
        displayName: "Account Name",
        backendName: "AccountName",
        isDisplayed: true,
      },
      {
        displayName: "Account ID",
        backendName: "AccountID",
        isDisplayed: false,
      },
      {
        displayName: "Manufacturer Name",
        backendName: "ManufacturerName",
        isDisplayed: true,
      },
      {
        displayName: "Manufacturer ID",
        backendName: "ManufacturerID",
        isDisplayed: false,
      },
      {
        displayName: "Order Total",
        backendName: "OrderTotal",
        isDisplayed: true,
      },
      {
        displayName: "Status",
        backendName: "Status",
        isDisplayed: true,
      },
      {
        displayName: "Action",
        backendName: "",
        isDisplayed: true,
        isFormatter: true,
        formatterType: "redirectButton",
      },
    ],
    InvoiceHomePaymentsApplied: [
      {
        displayName: "ID",
        backendName: "ID",
        isDisplayed: false,
      },
      {
        displayName: "Check Number",
        backendName: "CheckNumber",
        isDisplayed: true,
      },
      {
        displayName: "Applied Date",
        backendName: "AppliedDate",
        isDisplayed: true,
      },
      {
        displayName: "Account ID",
        backendName: "AccountID",
        isDisplayed: false,
      },
      {
        displayName: "Account Name",
        backendName: "AccountName",
        isDisplayed: true,
      },
      {
        displayName: "Invoice ID",
        backendName: "InvoiceID",
        isDisplayed: false,
      },
      {
        displayName: "Invoice",
        backendName: "InvoiceNumber",
        isDisplayed: true,
      },
      {
        displayName: "Payment Total",
        backendName: "AppliedTotal",
        isDisplayed: true,
      },
      {
        displayName: "Action",
        backendName: "",
        isDisplayed: true,
        isFormatter: true,
        formatterType: "",
      },
    ],
    IVRSubmissions: [
      {
        displayName: "ID",
        backendName: "ID",
        isDisplayed: false,
      },
      {
        displayName: "IVRAS ID",
        backendName: "IVRASID",
        isDisplayed: true,
        isSearchable: true,
      },
      {
        displayName: "Submit Date",
        backendName: "SubmissionDate",
        isDisplayed: true,
        isSearchable: true,
      },
      {
        displayName: "Account Name",
        backendName: "AccountName",
        isDisplayed: true,
      },
      {
        displayName: "Account ID",
        backendName: "AccountID",
        isDisplayed: false,
      },
      {
        displayName: "ManufacturerIntials",
        backendName: "ManufacturerIntials",
        isDisplayed: false,
      },
      {
        displayName: "Insurance Status",
        backendName: "InsuranceStatus",
        isDisplayed: false,
      },
      {
        displayName: "Case ID Status",
        backendName: "CaseIDStatus",
        isDisplayed: true,
        isSpecial: true,
      },
      {
        displayName: "Action",
        backendName: "",
        isDisplayed: true,
        isFormatter: true,
        formatterType: "redirectButton",
      },
    ],
    AccountProductLog: [
      {
        displayName: "ID",
        backendName: "ID",
        isDisplayed: false,
      },
      {
        displayName: "TissueID",
        backendName: "TissueID",
        isDisplayed: true,
        isSearchable: true,
      },
      {
        displayName: "Product Name",
        backendName: "ProductName",
        isDisplayed: false,
      },
      {
        displayName: "Product Code",
        backendName: "ProductCode",
        isDisplayed: true,
        isSearchable: true,
      },
      {
        displayName: "Order Type",
        backendName: "OrderType",
        isDisplayed: false,
      },
      {
        displayName: "Patient",
        backendName: "Patient",
        isDisplayed: true,
        isSearchable: true,
      },
      {
        displayName: "Application Date",
        backendName: "ApplicationDate",
        isDisplayed: true,
      },
      {
        displayName: "Application #",
        backendName: "ApplicationNumber",
        isDisplayed: true,
      },
      // {
      //   displayName: 'Invoice',
      //   backendName: 'InvoiceNumber',
      //   isDisplayed: true,
      // },
      {
        displayName: "Cost",
        backendName: "Price",
        isDisplayed: true,
      },
      {
        displayName: "TissueTrackingFile",
        backendName: "TissueTrackingFile",
        isDisplayed: false,
      },
      {
        displayName: "TissueTrackingFileName",
        backendName: "TissueTrackingFileName",
        isDisplayed: false,
      },
      {
        displayName: "Action",
        backendName: "",
        isDisplayed: true,
        isFormatter: true,
        formatterType: "redirectButton",
      },
    ],
    IVRManufacturers: [
      {
        displayName: "ID",
        backendName: "ID",
        isDisplayed: false,
      },
      {
        displayName: "IVR ID",
        backendName: "IVRID",
        isDisplayed: false,
      },
      {
        displayName: "Manufacturer ID",
        backendName: "ManufacturerID",
        isDisplayed: false,
      },
      {
        displayName: "Manufacturer Name",
        backendName: "ManufacturerName",
        isDisplayed: true,
      },
      {
        displayName: "Case ID",
        backendName: "CaseID",
        isDisplayed: true,
      },
      {
        displayName: "Insurance Status",
        backendName: "InsuranceStatus",
        isDisplayed: true,
      },
      {
        displayName: "Action",
        backendName: "",
        isDisplayed: true,
        isFormatter: true,
        formatterType: "redirectButton",
      },
    ],
    AccountConsignmentDashboard: [
      {
        displayName: "ID",
        backendName: "ID",
        isDisplayed: false,
      },
      {
        displayName: "Tissue ID",
        backendName: "TissueID",
        isDisplayed: true,
        isSearchable: true,
      },
      {
        displayName: "Product Code",
        backendName: "ProductCode",
        isDisplayed: true,
        isSearchable: true,
      },
      {
        displayName: "Ship Date",
        backendName: "ShipDate",
        isDisplayed: true,
      },
      {
        displayName: "Expiration Date",
        backendName: "ExpirationDate",
        isDisplayed: true,
      },
      {
        displayName: "Days on Consignment",
        backendName: "DaysOnConsignment",
        isDisplayed: true,
      },
      {
        displayName: "Action",
        backendName: "",
        isDisplayed: true,
        isFormatter: true,
        formatterType: "modalButtonConsignmentLog",
      },
    ],
    ManufacturerAccountDashboard: [
      {
        displayName: "ID",
        backendName: "ID",
        isDisplayed: false,
      },
      {
        displayName: "Account Name",
        backendName: "AccountName",
        isDisplayed: true,
      },
      {
        displayName: "Action",
        backendName: "",
        isDisplayed: true,
        isFormatter: true,
        formatterType: "redirectButton",
      },
    ],
    ASUsersDashboard: [
      {
        displayName: "ID",
        backendName: "ID",
        isDisplayed: false,
      },
      {
        displayName: "Name",
        backendName: "Name",
        isDisplayed: true,
      },
      {
        displayName: "Role",
        backendName: "RoleType",
        isDisplayed: true,
        isSpecial: true,
      },
      {
        displayName: "Region",
        backendName: "RegionID",
        isDisplayed: false,
      },
      {
        displayName: "Region",
        backendName: "RegionName",
        isDisplayed: false,
      },
      {
        displayName: "Region",
        backendName: "Region",
        isDisplayed: true,
        isSpecial: true,
      },
      {
        displayName: "Email",
        backendName: "Email",
        isDisplayed: true,
      },
      {
        displayName: "Phone",
        backendName: "Phone",
        isDisplayed: true,
      },
      {
        displayName: "Provider NPI",
        backendName: "ProviderNPI",
        isDisplayed: true,
      },
      {
        displayName: "Action",
        backendName: "",
        isDisplayed: true,
        isFormatter: true,
        formatterType: "redirectButton",
      },
    ],
    AccountUserDashboard: [
      {
        displayName: "ID",
        backendName: "ID",
        isDisplayed: false,
      },
      {
        displayName: "UserID",
        backendName: "UserID",
        isDisplayed: false,
      },
      {
        displayName: "Name",
        backendName: "Name",
        isDisplayed: true,
      },
      {
        displayName: "AccountID",
        backendName: "AccountID",
        isDisplayed: false,
      },
      {
        displayName: "Account",
        backendName: "AccountName",
        isDisplayed: true,
      },
      {
        displayName: "Email",
        backendName: "Email",
        isDisplayed: true,
      },
      {
        displayName: "Phone",
        backendName: "Phone",
        isDisplayed: true,
      },
      {
        displayName: "Action",
        backendName: "",
        isDisplayed: true,
        isFormatter: true,
        formatterType: "redirectButton",
      },
    ],
    DistributorUserDashboard: [
      {
        displayName: "ID",
        backendName: "ID",
        isDisplayed: false,
      },
      {
        displayName: "UserID",
        backendName: "UserID",
        isDisplayed: false,
      },
      {
        displayName: "Name",
        backendName: "Name",
        isDisplayed: true,
      },
      {
        displayName: "DistributorID",
        backendName: "DistributorID",
        isDisplayed: false,
      },
      {
        displayName: "Distributor",
        backendName: "DistributorName",
        isDisplayed: true,
      },
      {
        displayName: "Email",
        backendName: "Email",
        isDisplayed: true,
      },
      {
        displayName: "Phone",
        backendName: "Phone",
        isDisplayed: true,
      },
      {
        displayName: "Action",
        backendName: "",
        isDisplayed: true,
        isFormatter: true,
        formatterType: "redirectButton",
      },
    ],
    PaymentsAppliedDashboard: [
      {
        displayName: "ID",
        backendName: "ID",
        isDisplayed: false,
      },
      {
        displayName: "Check Number",
        backendName: "CheckNumber",
        isDisplayed: true,
        isSearchable: true,
      },
      {
        displayName: "Applied Date",
        backendName: "AppliedDate",
        isDisplayed: true,
      },
      {
        displayName: "Account ID",
        backendName: "AccountID",
        isDisplayed: false,
      },
      {
        displayName: "Account Name",
        backendName: "AccountName",
        isDisplayed: true,
        isSearchable: true,
      },
      {
        displayName: "Invoice ID",
        backendName: "InvoiceID",
        isDisplayed: false,
      },
      {
        displayName: "Invoice",
        backendName: "InvoiceNumber",
        isDisplayed: true,
        isSearchable: true,
      },
      {
        displayName: "Payment Total",
        backendName: "AppliedTotal",
        isDisplayed: true,
      },
      {
        displayName: "Action",
        backendName: "",
        isDisplayed: true,
        isFormatter: true,
        formatterType: "",
      },
    ],
    CommissionContracts: [
      {
        displayName: "ID",
        backendName: "ID",
        isDisplayed: false,
      },
      {
        displayName: "DistributorID",
        backendName: "DistributorID",
        isDisplayed: false,
      },
      {
        displayName: "DistributorName",
        backendName: "DistributorName",
        isDisplayed: false,
      },
      {
        displayName: "StartDate",
        backendName: "StartDate",
        isDisplayed: true,
      },
      {
        displayName: "EndDate",
        backendName: "EndDate",
        isDisplayed: true,
      },
      {
        displayName: "Created By",
        backendName: "CreatedBy",
        isDisplayed: true,
      },
      {
        displayName: "UploadContract",
        backendName: "UploadContract",
        isDisplayed: false,
      },
      {
        displayName: "Action",
        backendName: "",
        isDisplayed: true,
        isFormatter: true,
        formatterType: "",
      },
    ],
    NewContractProductGroups: [
      {
        displayName: "ID",
        backendName: "ID",
        isDisplayed: false,
      },
      {
        displayName: "ManufacturerID",
        backendName: "ManufacturerID",
        isDisplayed: false,
      },
      {
        displayName: "Manufacturer Name",
        backendName: "ManufacturerName",
        isDisplayed: true,
      },
      {
        displayName: "Product Group Name",
        backendName: "ProductGroupName",
        isDisplayed: true,
      },
      {
        displayName: "Commission %",
        backendName: "CommissionPercentage",
        isDisplayed: true,
      },
    ],
    ManufacturerCommissionContracts: [
      {
        displayName: "ID",
        backendName: "ID",
        isDisplayed: false,
      },
      {
        displayName: "ManufacturerID",
        backendName: "ManufacturerID",
        isDisplayed: false,
      },
      {
        displayName: "ManufacturerName",
        backendName: "ManufacturerName",
        isDisplayed: false,
      },
      {
        displayName: "StartDate",
        backendName: "StartDate",
        isDisplayed: true,
      },
      {
        displayName: "EndDate",
        backendName: "EndDate",
        isDisplayed: true,
      },
      {
        displayName: "Created By",
        backendName: "CreatedBy",
        isDisplayed: true,
      },
      {
        displayName: "UploadContract",
        backendName: "UploadContract",
        isDisplayed: false,
      },
      {
        displayName: "Action",
        backendName: "",
        isDisplayed: true,
        isFormatter: true,
        formatterType: "",
      },
    ],
    DistributorReferralContracts: [
      {
        displayName: "ID",
        backendName: "ID",
        isDisplayed: false,
      },
      {
        displayName: "DistributorID",
        backendName: "DistributorID",
        isDisplayed: false,
      },
      {
        displayName: "DistributorName",
        backendName: "DistributorName",
        isDisplayed: false,
      },
      {
        displayName: "RefereeDistributorID",
        backendName: "RefereeDistributorID",
        isDisplayed: false,
      },
      {
        displayName: "RefereeDistributor",
        backendName: "RefereeDistributorName",
        isDisplayed: true,
      },
      {
        displayName: "StartDate",
        backendName: "StartDate",
        isDisplayed: true,
      },
      {
        displayName: "EndDate",
        backendName: "EndDate",
        isDisplayed: true,
      },
      {
        displayName: "Created By",
        backendName: "CreatedBy",
        isDisplayed: true,
      },
      {
        displayName: "UploadContract",
        backendName: "UploadContract",
        isDisplayed: false,
      },
      {
        displayName: "Action",
        backendName: "",
        isDisplayed: true,
        isFormatter: true,
        formatterType: "",
      },
    ],
  };
}
